import { Clock, Eye, MousePointerClick, Percent, Users } from "lucide-react";
import type { Totals } from "../lib/api";
import { formatDuration, formatPercent, nf } from "../lib/format";

export function StatCards({ totals }: { totals: Totals }) {
  const items = [
    { label: "Pengunjung", value: nf.format(totals.visitors), icon: Users },
    { label: "Kunjungan", value: nf.format(totals.visits), icon: MousePointerClick },
    { label: "Pageview", value: nf.format(totals.pageviews), icon: Eye },
    { label: "Rasio bounce", value: formatPercent(totals.bounces, totals.visits), icon: Percent },
    {
      label: "Durasi rata-rata",
      value: formatDuration(totals.visits ? Math.round(totals.total_time / totals.visits) : 0),
      icon: Clock,
    },
  ];

  return (
    <dl className="grid grid-cols-2 gap-3 sm:grid-cols-5">
      {items.map((item) => (
        <div key={item.label} className="card p-3.5">
          <dt className="flex items-center gap-1.5 text-xs font-medium text-slate-500">
            <item.icon size={14} className="text-emerald-600" />
            {item.label}
          </dt>
          <dd className="mt-1.5 text-2xl font-semibold tabular-nums text-slate-900">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
